import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

import { HubTableTemplate } from "../../components";
import { getHeaderItems, getKeys, buildRows } from "./helper";
import ThroughputWorkOrdersTable from "../ThroughputWorkOrdersTable";
import { StyledTableStack } from "./styles";

export const ThroughputTable = ({
  weeks = [],
  customers = [],
  weekTotals = {},
  weekHealth = {},
  mode,
  isLoading,
}) => {
  const navigate = useNavigate();

  const onNavigate = (customerId) => navigate(`/customers/${customerId}`);

  const headerItems = getHeaderItems(weeks);
  const keys = getKeys(weeks, onNavigate);
  const rows = buildRows(customers, weekTotals, weekHealth);

  if (!isLoading && !customers.length) {
    return (
      <Typography
        variant="caption"
        fontSize={12}
        color="text.secondary"
        textAlign="center"
        py="40px"
      >
        No scheduled work orders found for this date range
      </Typography>
    );
  }

  return (
    <StyledTableStack>
      <HubTableTemplate
        id="ThroughputTable"
        headerProps={{ items: headerItems, includeChevron: true }}
        bodyProps={{
          items: rows,
          keys,
          includeChevron: true,
          RenderElement: ThroughputWorkOrdersTable,
          RenderElementProps: { mode, weeks },
        }}
        isLoading={isLoading}
      />
    </StyledTableStack>
  );
};

export default ThroughputTable;
